const { settingsActions } = require('@redux/slices/settings');
const { getAppDispatch } = require('@utilities/dispatch.util');

const settingDataManipulation = ({ data }) => {
  const settings = Object.keys(data).reduce((acc, curr) => {
    let value = data[curr];
    value = curr.endsWith('DisplayFields') ? (value ? value.join(',') : '') : value;
    acc[curr] = value;
    return acc;
  }, data);

  return { settings };
};

const settingDataDispatcher = ({ data, initialLogin }) => {
  const dispatch = getAppDispatch();

  if (initialLogin) {
    dispatch?.(settingsActions.setInitialLoginSettings(data.settings));
  } else {
    dispatch?.(settingsActions.setSettings(data.settings));
  }
};

export { settingDataManipulation, settingDataDispatcher };
